import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import '@/styles/main.scss'
import Toast from 'vue-toastification'
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
import { PiniaVuePlugin } from 'pinia'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import { EmailEditor } from 'vue-email-editor'
import VueApexCharts from 'vue-apexcharts'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import pinia from './store/pinia'
import router from './router'
import store from './store'
import 'tiptap-vuetify/dist/main.css'
import './plugins/acl'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false
Vue.use(Toast)
Vue.use(VueTheMask)
Vue.use(PiniaVuePlugin)
Vue.use(EmailEditor)
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
})
Vue.use(VueApexCharts)

new Vue({
  pinia,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
